import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Envelope, DownloadSimple, Tag } from "@phosphor-icons/react";

const download = async (fmt) => {
  const t = toast.loading("Génération du fichier…");
  const isPdf = fmt === "cnil";
  try {
    const res = await api.get(isPdf ? "/admin/cnil-registre" : `/admin/social/id-announcement?fmt=${fmt}`, { responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = isPdf ? "registre-cnil-doudou-alert.pdf" : fmt === "square" ? "doudou-alert-id-carre.png" : "doudou-alert-id-story.png";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    toast.success("Visuel téléchargé !", { id: t });
  } catch {
    toast.error("Impossible de générer le visuel", { id: t });
  }
};

export const AdminIdCampaign = () => {
  const [pending, setPending] = useState(null);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    api.get("/admin/id-emails/status").then(({ data }) => setPending(data.pending)).catch(() => setPending(0));
  }, []);

  const send = async () => {
    if (!window.confirm(`Envoyer le mail ID à ${pending} famille(s) ? Chaque famille ne le recevra qu'une seule fois.`)) return;
    setSending(true);
    try {
      const { data } = await api.post("/admin/id-emails/send");
      toast.success(`Envoi lancé pour ${data.queued} famille(s)`);
      setPending(0);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erreur d'envoi");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="mt-8 bg-white border border-orange-200 rounded-3xl p-5 space-y-5" data-testid="admin-id-campaign">
      <p className="font-display font-bold text-stone-800 flex items-center gap-2">
        <Tag size={20} weight="duotone" className="text-orange-500" /> Campagne « ID unique des doudous »
      </p>
      <div>
        <p className="text-sm text-stone-600">
          Envoie à chaque famille déjà inscrite un mail avec l'ID de chacun de ses doudous et le lien vers l'article.
          Familles en attente : <strong data-testid="admin-id-emails-pending">{pending ?? "…"}</strong>
        </p>
        <button
          onClick={send}
          disabled={!pending || sending}
          className="mt-3 inline-flex items-center gap-2 bg-orange-500 hover:bg-orange-600 disabled:opacity-50 text-white font-bold rounded-full px-5 py-2.5"
          data-testid="admin-send-id-emails-button"
        >
          <Envelope size={18} weight="bold" /> {sending ? "Envoi…" : pending === 0 ? "Toutes les familles l'ont reçu" : "Envoyer le mail ID aux familles"}
        </button>
      </div>
      <div>
        <p className="text-sm text-stone-600">Visuels réseaux sociaux prêts à poster et registre CNIL à jour :</p>
        <div className="mt-3 flex flex-wrap gap-3">
          <button onClick={() => download("square")} className="inline-flex items-center gap-2 border-2 border-rose-200 text-rose-600 hover:bg-rose-50 font-bold rounded-full px-5 py-2.5" data-testid="admin-download-id-square">
            <DownloadSimple size={18} weight="bold" /> Publication 1080×1080
          </button>
          <button onClick={() => download("story")} className="inline-flex items-center gap-2 border-2 border-rose-200 text-rose-600 hover:bg-rose-50 font-bold rounded-full px-5 py-2.5" data-testid="admin-download-id-story">
            <DownloadSimple size={18} weight="bold" /> Story 1080×1920
          </button>
          <button onClick={() => download("cnil")} className="inline-flex items-center gap-2 border-2 border-stone-200 text-stone-600 hover:bg-stone-50 font-bold rounded-full px-5 py-2.5" data-testid="admin-download-cnil">
            <DownloadSimple size={18} weight="bold" /> Registre CNIL (PDF)
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminIdCampaign;
